import React, { useEffect, useState } from "react";
const apiUrl = import.meta.env.VITE_API_URL;

function AllPlayer() {
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dataLength, setDataLength] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/players`);
        let data = await response.json();
        setDataLength(data.length);

        // Sort by latest created_at
        data = data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setUserData(data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <p className="text-white text-2xl">Loading...</p>
      </div>
    );
  }
  

  return (
    <div className="min-h-screen bg-transparent text-white pb-10 px-4">
      {/* Title */}
      <h1 className="text-2xl sm:text-4xl font-bold text-center mb-8">
        Players List <span className="text-gray-400">({dataLength})</span>
      </h1>

      {/* Player Cards */}
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
        {userData.map((player, index) => (
          <div
            key={player.id}
            className="bg-white/10 backdrop-blur-md p-5 rounded-2xl shadow-lg flex flex-col items-center hover:scale-105 transition-transform duration-300"
          >
            {/* Player Photo */}
            <img
              src={player.photo || "https://via.placeholder.com/150"}
              alt={player.name}
              className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-white shadow-md mb-4"
            />

            {/* Player Info */}
            <h2 className="text-lg font-semibold mb-1 text-center">
              {player.name} {player?.islocal === 1 ? "" : "✈️"}
            </h2>
           <p className="text-sm text-gray-300 font-semibold mb-1">
              {(() => {
                switch (player?.role) {
                  case 1:
                    return "Batsman";
                  case 2:
                    return "Wicket-Keeper";
                  case 3:
                    return "Batsman-Allrounder";
                  case 4:
                    return "Bowler-Allrounder";
                  case 5:
                    return "Bowler";
                  default:
                    return "Unknown";
                }
              })()}
            </p>
            <p className="text-sm text-gray-300 text-center mb-1">
              {player?.address
                ?.split(" ")
                .map(
                  (word) =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join(" ") || "N/A"}
            </p>
            <p className="text-sm text-gray-300 mb-1">
              📞 <a href={`tel:${player.phone}`}>{player.phone}</a>
            </p>
            <p className="text-sm text-gray-300 mb-1">
              {player.base_price}
            </p>
            

            {/* Extra Highlight */}
            <div
              className={`mt-3 text-xs px-3 py-1 rounded-full text-white ${
                index % 3 === 0
                  ? "bg-gradient-to-r from-purple-600 to-pink-500"
                  : index % 3 === 1
                  ? "bg-gradient-to-r from-blue-600 to-indigo-500"
                  : "bg-gradient-to-r from-green-600 to-emerald-500"
              }`}
            >
              Player ID: {player.id}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AllPlayer;
